// @ts-nocheck
import { InitPage } from "../../index";

declare var setPrinterUrl: string;
declare var reprintLabelUrl: string;
declare var printPlateUrl: string;

class Generate {
  constructor() {
    $("#lot_date, #expiration_date").datepicker({
      format: "yyyy-mm-dd HH:ii p",
    });

    $("#exp-date, #lot-date").on("click", function (e) {
      e.preventDefault();
      $(this).datepicker("show");
    });

    $(".view_details").on("click", (e) => {
      $("#json_data").html(e.currentTarget.dataset.json);
      $("#showDetails").modal("show");
    });

    $("#checkAll").on("click", () => {
      const checked = $("#checkAll").is(":checked");
      $.each($(".tag:enabled"), function () {
        $(this).prop("checked", checked);
      });
    });

    $("#checkAll, .tag").on("click", () => {
      if ($(".tag:checked").length === 0) {
        $("#print_lic_plate").attr("disabled", "disabled");
        $("#print_lic_plate").addClass("disabled");
        $("#print_rfid_label").attr("disabled", "disabled");
        $("#print_rfid_label").addClass("disabled");
      } else {
        $("#print_lic_plate").removeAttr("disabled");
        $("#print_lic_plate").removeClass("disabled");
        $("#print_rfid_label").removeAttr("disabled");
        $("#print_rfid_label").removeClass("disabled");
      }
    });

    $("#print-submit").on("click", function () {
      const form = $(this).closest("form");
      if (form.valid()) {
        $(this).attr("disabled", true);
        $(this).addClass("disable_link hover-cursor-not-allowed");
      }
      $("#print-submit-btn").trigger("click");
    });

    // When changing the selected printer auto-save it to the server
    $("#printer_id").on("change", (e) => {
      $.ajax({
        url: setPrinterUrl,
        method: "POST",
        data: { printer: $(e.target).val() },
      });
      setTimeout(() => history.go(0), 1500);
    });

    $("#print_rfid_label").on("click", (_e) => {
      window.location.href = `${reprintLabelUrl}?ids[]=${selected_ids().join(
        "&ids[]=",
      )}`;
    });

    $("#print_lic_plate").on("click", (_e) => {
      window.location.href = `${printPlateUrl}?ids[]=${selected_ids().join(
        "&ids[]=",
      )}`;
    });

    $("#pallet_count, #box_count, #unit_count, #uom").on(
      "keyup, change",
      (_e) => {
        let labels = 1;
        let qty = 1;

        const palletCount = $("#pallet_count").val();
        const boxCount = $("#box_count").val();
        const unitCount = $("#unit_count").val();
        const uom = $("#uom").val() || "";

        if (palletCount.length) {
          labels = palletCount;
          qty = parseInt(boxCount || "1", 10) * parseInt(unitCount || "1", 10);
        } else if (boxCount.length) {
          labels = boxCount;
          qty = unitCount || "1";
        } else {
          labels = unitCount || "1";
        }

        $("#print-message").html(
          `${labels} Label(s) will be printed with QTY ${qty} ${uom}`,
        );
      },
    );

    function selected_ids() {
      const values = [];
      $.each($(".tag:checked"), function () {
        values.push($(this).val());
      });
      return values;
    }
  }
}

export function LoadPage() {
  InitPage("generate", () => {
    new Generate();
  });
}
